var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CompassDialog", {
        ref: "importRevertDialog",
        staticClass: "import-revert-dialog",
        attrs: {
          size: "small",
          title: _vm.$t.__("settings.import.ImportRevertPopup.cancel_import"),
          visible: _vm.showDialog
        },
        on: {
          "update:visible": function($event) {
            _vm.showDialog = $event
          },
          closed: function($event) {
            return _vm.$emit("closed")
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("CompassAlert", {
                  attrs: {
                    description: _vm.$t.__(
                      "settings.import.ImportRevertPopup.cancellation_and_restoration__data_possible_within_24_hours"
                    ),
                    "show-close": false
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "description-dialog typographies-paragraph-medium-regular"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Si vous constatez un problème dans vos données Sellsy depuis que vous avez effectué cet import, annulez le facilement pour restaurer l’ensemble des données impactées."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  { staticClass: "subtitle-card typographies-heading-h4" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Récapitulatif des actions effectuées lors de l'annulation"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card card-container" },
                  [
                    _vm.isImportTitleSimple
                      ? _c("CompassObject", {
                          attrs: {
                            size: "small",
                            label: _vm.typeImport.title,
                            object: _vm.importTypeObject
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeImport.titleSegments !== undefined
                      ? _c(
                          "div",
                          {
                            staticClass: "compass-object compass-object--small"
                          },
                          [
                            _c("CompassIcon", {
                              attrs: {
                                icon: _vm.typeImport.icon,
                                size: "medium"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "compass-object__text" }, [
                              _c(
                                "h4",
                                _vm._l(_vm.typeImport.titleSegments, function(
                                  segment,
                                  idx
                                ) {
                                  return _c(
                                    "span",
                                    { class: _vm.getImportTitleClasses(idx) },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getImportTitleSegmentText(
                                              idx,
                                              segment
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-container__list all-lines-treated" },
                      [
                        _c("p", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__("Annulation des lignes traitées")
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "card-container__infos typographies-paragraph-medium-semibold"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.importToRevert.processed_rows) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-container__categories" },
                      _vm._l(_vm.typeImport.displaySubTypeOrder, function(
                        subType,
                        key
                      ) {
                        return _c("div", { key: key }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getResultLabel(subType)) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-container__list" }, [
                            _c("ul", [
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "typographies-paragraph-medium-regular"
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.getCancelModificationText()) +
                                      "\n                                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "card-container__infos typographies-paragraph-medium-semibold"
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.importToRevert.results[subType]
                                        .updated || 0
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isPriceImportType()
                            ? _c(
                                "div",
                                { staticClass: "card-container__list" },
                                [
                                  _c("ul", [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Suppression des ajouts"
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-container__infos typographies-paragraph-medium-semibold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.importToRevert.results[subType]
                                              .created || 0
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "import-revert-dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.showDialog = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        type: "primary-destructive",
                        label: _vm.$t.__(
                          "settings.import.ImportRevertPopup.cancel_import"
                        )
                      },
                      on: { click: _vm.onRevertImport }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }